var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 9.16658H10.833V4.16659C10.833 3.94557 10.7452 3.73361 10.5889 3.57733C10.4326 3.42105 10.2207 3.33325 9.99967 3.33325C9.77866 3.33325 9.5667 3.42105 9.41042 3.57733C9.25414 3.73361 9.16634 3.94557 9.16634 4.16659V9.16658H4.16634C3.94533 9.16658 3.73337 9.25438 3.57709 9.41066C3.42081 9.56694 3.33301 9.7789 3.33301 9.99992C3.33301 10.2209 3.42081 10.4329 3.57709 10.5892C3.73337 10.7455 3.94533 10.8333 4.16634 10.8333H9.16634V15.8333C9.16634 16.0543 9.25414 16.2662 9.41042 16.4225C9.5667 16.5788 9.77866 16.6666 9.99967 16.6666C10.2207 16.6666 10.4326 16.5788 10.5889 16.4225C10.7452 16.2662 10.833 16.0543 10.833 15.8333V10.8333H15.833C16.054 10.8333 16.266 10.7455 16.4223 10.5892C16.5785 10.4329 16.6663 10.2209 16.6663 9.99992C16.6663 9.7789 16.5785 9.56694 16.4223 9.41066C16.266 9.25438 16.054 9.16658 15.833 9.16658Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus2);
export default __webpack_public_path__ + "static/media/Plus 2.6e0a0362a190ccb2594522a1f7d7f1e3.svg";
export { ForwardRef as ReactComponent };